// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J2hYY","newExpiryDate":"styles_newExpiryDate__VzK47","footer":"styles_footer__4oTLN"};